module.exports = __webpack_public_path__ + "img/user-03.343abb1b.svg";